import { render, staticRenderFns } from "./_product.vue?vue&type=template&id=17aa4482&"
import script from "./_product.vue?vue&type=script&lang=js&"
export * from "./_product.vue?vue&type=script&lang=js&"
import style0 from "./_product.vue?vue&type=style&index=0&id=17aa4482&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports